import {
    WithId,
} from 'app/types/common.types'
import GatewayUpdate from '../GatewayUpdate'
import GatewayComments from '../GatewayComments'

const GatewayOverview = ({
    id,
}: Readonly<WithId<number>>) => {
    return (
        <>
            <GatewayUpdate
                id={id}
                disabled
            />
            <GatewayComments gatewayId={id} />
        </>
    )
}

export default GatewayOverview
